import React from 'react'
import WorkFlowCalendarContainer from './Calendars/WorkFlowCalendarContainer'

export default function WorkFlowCalendarSection({ calendars }) {
  return (
    <WorkFlowCalendarContainer calendars={calendars} />
  )
}
